export const button_links_class = "vanilla-btn-links";
